import React, {Component} from 'react';
import './App.css';

import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import Home from "./Home";
import ForgotPassword from "./Auth/ForgotPassword";
import InfoPage from "./utils/InfoPage";
import DocumentationHome from "./documentation/DocumentationHome";
import {createTheme} from "@mui/material";
import { ThemeProvider} from "@mui/styles";
import { StyledEngineProvider} from "@mui/material";
import SignUp from "./Auth/SignUp";
import {CookiesProvider} from "react-cookie";

const theme = createTheme();

class App extends Component{
  componentDidMount() {
      document.getElementById('app').addEventListener('wheel', e => e );
  }


   render() {

    return (
        <CookiesProvider>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <div className="App" id='app'>
                        <div className='app-content'>
                            <Router basename="/" >
                                <Routes >
                                    {/*<Route path="/home" render={props => <AdminDashboard account={{}} />} />*/}
                                    {/*<Route path="/signUp" component={SignUp} />*/}

                                    {/*react router ver 5.3.0*/}
                                    {/*<Route path="/doc" component={DocumentationHome} />*/}
                                    {/*<Route path="/info" component={InfoPage} />*/}
                                    {/*<Route path="/forgotPassword" component={ForgotPassword} />*/}
                                    {/*<Route path="/" component={Home}/>*/}

                                    {/* react router ver 6 */}
                                    <Route path="/signUp" element={<SignUp/>} />
                                    <Route path="/doc" element={<DocumentationHome/>} />
                                    <Route path="/info" element={<InfoPage/>} />
                                    <Route path="/forgotPassword" element={<ForgotPassword/>} />
                                    <Route path="/*" element={<Home/>} />

                                </Routes>
                            </Router>
                        </div>
                    </div>
                </ThemeProvider>
            </StyledEngineProvider>
        </CookiesProvider>
    );
  }
}


export default App;
